// default delay for AWS-UI components defined by UX
export var DEBOUNCE_DEFAULT_DELAY = 200;
export default function debounce(func, delay) {
    if (delay === void 0) { delay = DEBOUNCE_DEFAULT_DELAY; }
    var timeout;
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(function () {
            timeout = null;
            func.apply(_this, args);
        }, delay);
    };
}
//# sourceMappingURL=debounce.js.map